module.exports = __webpack_public_path__ + "static/AL-55bee3d7f4732c9fdc303833afd7bf34.jpg";